// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   Home — GrowFit 신규 디자인 (Figma 29:17740 / Home - dashboard)
   3컬럼 레이아웃: 좌측(프로필/알림/공지/푸터) · 중앙(빠른 시작/이어서 하기) · 우측(에이전트)
   헤더는 components/AppHeader (별도 CSS)
   폰트 사양 (피그마 Pretendard variants):
     Light 300 · Regular 400 · Medium 500 · SemiBold 600 · Bold 700
   ======================================================================== */

.home {
  min-height: 100vh;
  background: var(--fg-bg-dark);
  font-family:
    'Pretendard Variable', 'Pretendard',
    -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  color: var(--fg-text-basic);
  letter-spacing: -0.005em;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  /* 홈 단일 포인트 액센트 — 네이비 구조색 + 인디고 액센트.
     시안/앰버 등으로 바꾸려면 이 두 줄만 수정하면 화면 전체에 반영됨. */
  --home-accent: #4c5ed9;
  --home-accent-strong: #3a49b0;
}

/* ───────── 상단: 개인화 인사 헤더 ───────── */
.home-greeting {
  max-width: 1880px;
  margin: 0 auto 24px;
  animation: home-rise 0.5s ease both;
}

.home-greeting__title {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.02em;
  color: var(--fg-text-basic);
}

.home-greeting__name {
  color: var(--home-accent);
}

.home-greeting__sub {
  margin: 6px 0 0;
  font-size: 15px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 1.4;
}

/* ───────── 진입 모션 (컬럼별 staggered reveal) ───────── */
@keyframes home-rise {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.home__col > * {
  animation: home-rise 0.45s ease both;
}

.home__col > *:nth-child(1) {
  animation-delay: 0.06s;
}
.home__col > *:nth-child(2) {
  animation-delay: 0.12s;
}
.home__col > *:nth-child(3) {
  animation-delay: 0.18s;
}
.home__col > *:nth-child(4) {
  animation-delay: 0.24s;
}

@media (prefers-reduced-motion: reduce) {
  .home-greeting,
  .home__col > * {
    animation: none;
  }
}

/* ───────── 본문 ─────────
   피그마 Contens Box BG 토큰은 #f2f2f2지만 실제 시안은 흰색 배경으로 보이므로 #fff 사용.
   카드/리스트 항목 사이의 미세 회색 라인은 1px border와 #f8f8f8 박스로 구분. */
.home__body {
  background: #ffffff;
  border-radius: 16px 16px 0 0;
  margin: 0 16px;
  padding: 20px 36px 60px;
  min-height: calc(100vh - 52px);
  box-shadow: 0 0 6.3px 1px rgba(0, 0, 0, 0.26);
}

.home__inner {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  max-width: 1880px;
  margin: 0 auto;
}

.home__col {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
}

/* ───────── 카드 공통 ───────── */
.home-card {
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  padding: 12px 16px 16px;
}

.home-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--fg-line);
  margin-bottom: 4px;
}

.home-card__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--fg-text-basic);
  line-height: 26px;
  margin: 0;
  letter-spacing: -0.01em;
}

.home-card__title--plain {
  font-size: 18px;
  font-weight: 600;
  color: #000;
  line-height: 28px;
  margin: 0;
  letter-spacing: -0.01em;
}

.home-card__head-action {
  background: transparent;
  border: 0;
  padding: 0;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic);
  cursor: pointer;
  line-height: 17px;
}

.home-card__head-action:hover {
  text-decoration: underline;
}

/* ───────── 프로필 카드 ───────── */
.home-card--profile {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 20px 20px 24px;
  background: var(--fg-bg-dark);
  border: 0;
  color: #fff;
  border-radius: 12px;
}

.home-card__avatar {
  flex-shrink: 0;
  width: 102px;
  height: 102px;
  border-radius: 9999px;
  overflow: hidden;
  background: linear-gradient(135deg, var(--home-accent), var(--home-accent-strong));
  display: grid;
  place-items: center;
}

.home-card__avatar-circle {
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 36px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

.home-card__profile-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.home-card__profile-head {
  display: flex;
  align-items: center;
  gap: 8px;
}

.home-card__role-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 6px;
  border: 1px solid var(--fg-line);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-bg-card);
  line-height: 1;
}

.home-card__name {
  flex: 1 1;
  margin: 0;
  font-size: 20px;
  font-weight: 500;
  color: #fff;
  letter-spacing: -0.01em;
}

.home-card__edit-btn {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-menu);
  cursor: pointer;
  padding: 0;
}

.home-card__edit-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}

.home-card__token-alert {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-menu);
  line-height: 1.2;
}

.home-card__token-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.home-card__token-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.home-card__token-label {
  display: flex;
  gap: 4px;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-menu);
  line-height: 1;
}

.home-card__token-label > span:first-child {
  flex: 1 1;
}

.home-card__token-value--alert {
  color: var(--fg-anti-red);
  font-weight: 600;
}

.home-card__token-bar {
  width: 100%;
  height: 5px;
  background: var(--fg-text-menu);
  border-radius: 10px;
  overflow: hidden;
}

.home-card__token-bar-fill {
  height: 100%;
  background: var(--home-accent);
  border-radius: 10px;
  transition: width 0.3s ease;
}

.home-card__token-bar-fill--alert {
  background: var(--fg-anti-red);
}

/* ───────── 알림 카드 ───────── */
.home-card--alarm {
  padding: 12px 16px 16px;
}

.home-card__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.home-card__alarm-item {
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding: 10px 10px 10px 8px;
  background: #fff;
  border-radius: 12px;
  cursor: pointer;
  transition: var(--transition-fast);
}

.home-card__alarm-item:hover {
  background: var(--fg-bg-litepp);
}

.home-card__alarm-icon {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: grid;
  place-items: center;
  color: var(--fg-text-basic);
}

.home-card__alarm-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.home-card__alarm-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  line-height: 1;
  letter-spacing: -0.005em;
}

.home-card__alarm-time {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 1;
}

.home-card__alarm-dot {
  flex-shrink: 0;
  width: 5px;
  height: 5px;
  margin-top: 8px;
  background: var(--fg-anti-red);
  border-radius: 9999px;
}

.home-card__alarm-empty {
  padding: 10px 8px;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
}

/* ───────── 공지 사항 카드 ───────── */
.home-card--notice {
  padding: 12px 16px 16px;
}

.home-notice__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.home-notice__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 0;
  border-bottom: 1px solid var(--fg-line);
  cursor: pointer;
  transition: var(--transition-fast);
}

.home-notice__item:last-child {
  border-bottom: 0;
}

.home-notice__item:hover .home-notice__title {
  color: var(--fg-link);
}

.home-notice__title {
  flex: 1 1;
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  line-height: 1;
  letter-spacing: -0.005em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-notice__date {
  flex-shrink: 0;
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 1;
  text-align: right;
}

.home-notice__empty {
  margin: 0;
  padding: 16px 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-gray);
  text-align: center;
}

/* ───────── 공지 상세 모달 ───────── */
.notice-modal__overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 24px;
}

.notice-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1001;
  background: #ffffff;
  border-radius: 12px;
  width: min(720px, calc(100% - 48px));
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.notice-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  border-bottom: 1px solid var(--fg-line);
}

.notice-modal__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--fg-text-basic);
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
}

.notice-modal__close {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.notice-modal__close:hover {
  background: rgba(0, 0, 0, 0.05);
  color: var(--fg-text-basic);
}

.notice-modal__body {
  padding: 20px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.notice-modal__status {
  margin: 0;
  padding: 24px 0;
  text-align: center;
  font-size: 14px;
  color: var(--fg-text-gray);
}

.notice-modal__status--error {
  color: var(--fg-anti-red, #ff1500);
}

.notice-modal__meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.notice-modal__tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 9999px;
  background: var(--fg-bg-content, #f2f2f2);
  font-size: 12px;
  font-weight: 500;
  color: var(--fg-text-gray);
  line-height: 1;
}

.notice-modal__tag--pin {
  background: var(--fg-anti-red, #ff1500);
  color: #ffffff;
}

.notice-modal__date {
  margin-left: auto;
  font-size: 13px;
  color: var(--fg-text-gray);
}

.notice-modal__description {
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: var(--fg-text-basic);
  white-space: pre-wrap;
}

.notice-modal__content-body {
  font-size: 14px;
  line-height: 1.7;
  color: var(--fg-text-basic);
  word-break: break-word;
}

.notice-modal__content-body p {
  margin: 0 0 12px;
}

.notice-modal__content-body h1,
.notice-modal__content-body h2,
.notice-modal__content-body h3 {
  margin: 16px 0 8px;
  font-weight: 700;
}

.notice-modal__content-body ul,
.notice-modal__content-body ol {
  padding-left: 20px;
  margin: 0 0 12px;
}

.notice-modal__content-body a {
  color: var(--fg-link, var(--fg-button-hover));
  text-decoration: underline;
}

.notice-modal__content-body img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
}

.notice-modal__content-body pre,
.notice-modal__content-body code {
  background: var(--fg-bg-content, #f2f2f2);
  border-radius: 4px;
}

.notice-modal__content-body pre {
  padding: 12px;
  overflow-x: auto;
}

.notice-modal__content-body code {
  padding: 1px 4px;
  font-size: 13px;
}

/* ───────── 푸터 ───────── */
.home-footer {
  padding: 20px 12px 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  color: var(--fg-text-basic);
}

.home-footer__links {
  list-style: none;
  margin: 0 0 12px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.home-footer__links a {
  color: var(--fg-text-basic);
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
}

.home-footer__links a:hover {
  color: var(--fg-link-hover);
  text-decoration: underline;
}

.home-footer__brand {
  display: flex;
  align-items: center;
  gap: 20px;
  margin-top: 12px;
}

.home-footer__brand-img--gf {
  height: 36px;
  width: auto;
}

.home-footer__brand-img--bct {
  height: 24px;
  width: auto;
}

.home-footer__copy {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic);
  line-height: 1.4;
}

.home-footer__copy:first-of-type {
  font-weight: 500;
  margin-top: 8px;
}

.home-footer__copy b {
  font-weight: 700;
}

/* ───────── 중앙: 히어로 배너 ───────── */
/* ───────── 중앙: 빠른 시작 ───────── */
.home-quickstart {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.home-quickstart__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.home-quickstart__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.home-quickstart__tile {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  text-decoration: none;
  color: var(--fg-text-basic);
  transition:
    border-color var(--transition-fast),
    background-color var(--transition-fast),
    box-shadow var(--transition-fast);
}

.home-quickstart__tile:hover {
  border-color: var(--home-accent);
  background: var(--fg-bg-card);
  box-shadow: 0 2px 10px rgba(76, 94, 217, 0.12);
}

.home-quickstart__tile-icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border-radius: 10px;
  background: var(--fg-bg-content);
  color: var(--fg-bg-toolbox);
  transition:
    background-color var(--transition-fast),
    color var(--transition-fast);
}

.home-quickstart__tile:hover .home-quickstart__tile-icon {
  background: var(--home-accent);
  color: #fff;
}

.home-quickstart__tile-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.home-quickstart__tile-label {
  font-size: 15px;
  font-weight: 600;
  color: var(--fg-text-basic);
  line-height: 22px;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-quickstart__tile-desc {
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-quickstart__tile-arrow {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  color: var(--fg-line);
  transition:
    color var(--transition-fast),
    transform var(--transition-fast);
}

.home-quickstart__tile:hover .home-quickstart__tile-arrow {
  color: var(--home-accent);
  transform: translateX(2px);
}

/* ───────── 버튼 (프로필 카드 안 충전/업그레이드) ───────── */
.home-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  padding: 5px 7px 7px;
  background: var(--home-accent);
  border: 0;
  border-radius: 4px;
  color: #fff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  white-space: nowrap;
  transition: var(--transition-fast);
}

.home-btn:hover {
  background: var(--home-accent-strong);
}

/* ───────── 중앙: 이어서 하기 ───────── */
.home-continue {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.home-continue__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.home-continue__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.home-continue__item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    border-color var(--transition-fast),
    background-color var(--transition-fast);
}

.home-continue__item:hover {
  background: #fff;
  border-color: var(--home-accent);
}

.home-continue__item-logo {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 9999px;
  background: #fff;
  border: 1px solid var(--fg-line);
}

.home-continue__item-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.home-continue__item-title {
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  line-height: 20px;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-continue__item-meta {
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-continue__item-arrow {
  flex-shrink: 0;
  display: grid;
  place-items: center;
  color: var(--fg-line);
  transition:
    color var(--transition-fast),
    transform var(--transition-fast);
}

.home-continue__item:hover .home-continue__item-arrow {
  color: var(--home-accent);
  transform: translateX(2px);
}

.home-continue__loading {
  margin: 0;
  padding: 20px 16px;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-gray);
  text-align: center;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
}

.home-continue__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 28px 16px;
  background: #f8f8f8;
  border-radius: 12px;
  text-align: center;
}

.home-continue__empty-text {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-gray);
}

.home-continue__start {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  background: var(--home-accent);
  border: 0;
  border-radius: 8px;
  color: #fff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color var(--transition-fast);
}

.home-continue__start:hover {
  background: var(--home-accent-strong);
}

/* ───────── 우측: 에이전트 섹션 ───────── */
.home-agent-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  /* width:100% 필수 — 단일 컬럼 스택(모바일)에서 이 flex 컬럼이 부모 폭에 stretch되지 않고
     내부 nowrap 텍스트(에이전트 제목·설명, 프롬프트 요약)의 max-content로 늘어나
     카드가 가로로 폭주한다. 명시적 100%로 트랙(컬럼) 폭에 고정. 데스크탑에선 no-op. */
  width: 100%;
  min-width: 0;
}

.home-agent-section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.home-agent__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.home-agent__empty {
  padding: 16px;
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-gray, var(--fg-text-basic));
  background: #f8f8f8;
  border-radius: 12px;
  text-align: center;
}

.home-agent__item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 16px;
  background: var(--fg-bg-card, #fbfbfb);
  border-radius: 12px;
  transition:
    background-color var(--transition-fast),
    box-shadow var(--transition-fast),
    transform var(--transition-fast);
  cursor: pointer;
}

.home-agent__item:hover {
  background: #fff;
  box-shadow: 0 2px 10px rgba(76, 94, 217, 0.1);
}

.home-agent__thumb {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 9999px;
  display: grid;
  place-items: center;
  overflow: hidden;
  background: var(--fg-bg-card, #fbfbfb);
  padding: 8px;
  box-sizing: border-box;
}

.home-agent__item:hover .home-agent__thumb {
  background: #ffffff;
}

.home-agent__thumb--dark {
  background: var(--fg-bg-toolbox);
  color: #fff;
}

.home-agent__thumb--bct {
  background: var(--fg-bg-card);
  color: var(--fg-text-basic);
  border: 1px solid var(--fg-line);
}

.home-agent__thumb--empty {
  background: var(--fg-bg-content, #f2f2f2);
  color: var(--fg-text-gray);
}

.home-agent__thumb-initial {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
  font-size: 18px;
  font-weight: 700;
  color: inherit;
  letter-spacing: -0.01em;
}

.home-agent__thumb-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.home-agent__thumb-empty {
  display: grid;
  place-items: center;
  color: var(--fg-text-gray);
}

.home-agent__body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.home-agent__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--fg-text-basic);
  line-height: 28px;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-agent__desc {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic);
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-agent__meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 12px;
}

.home-agent__stats {
  display: flex;
  align-items: center;
  gap: 8px;
}

.home-agent__stat {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-gray);
  line-height: 1;
}

.home-agent__rank-delta {
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
}

.home-agent__rank-delta--up {
  color: var(--fg-anti-red);
}

.home-agent__rank-delta--down {
  color: var(--fg-button-hover);
}

.home-agent__actions {
  display: inline-flex;
  align-items: center;
}

.home-agent__action-count {
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  color: var(--fg-anti-red, #ff1500);
  white-space: nowrap;
  padding: 0 2px;
}

.home-agent__icon-btn {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
  padding: 0;
  transition: var(--transition-fast);
}

.home-agent__icon-btn:hover {
  background: rgba(0, 0, 0, 0.05);
  color: var(--fg-text-basic);
}

.home-agent__icon-btn--favorited {
  color: var(--fg-anti-red, #ff1500);
}

.home-agent__icon-btn--favorited:hover {
  color: var(--fg-anti-red, #ff1500);
}

/* ───────── 우측: 내 프롬프트 ───────── */
.home-prompt__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.home-prompt__item {
  width: 100%;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 16px;
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  transition:
    border-color var(--transition-fast),
    background-color var(--transition-fast),
    box-shadow var(--transition-fast);
}

.home-prompt__item:hover {
  background: #fff;
  border-color: var(--home-accent);
  box-shadow: 0 2px 10px rgba(76, 94, 217, 0.1);
}

.home-prompt__icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  background: var(--fg-bg-content);
  color: var(--fg-bg-toolbox);
  transition:
    background-color var(--transition-fast),
    color var(--transition-fast);
}

.home-prompt__item:hover .home-prompt__icon {
  background: var(--home-accent);
  color: #fff;
}

.home-prompt__body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.home-prompt__head {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.home-prompt__title {
  flex: 1 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--fg-text-basic);
  line-height: 22px;
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.home-prompt__date {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 1;
}

.home-prompt__summary {
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ───────── 반응형 ───────── */
@media (max-width: 1440px) {
  .home__inner {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  }
  .home__col:nth-child(3) {
    grid-column: 1 / -1;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 20px;
  }
  .home__col:nth-child(3) > * {
    flex: 1 1 280px;
    min-width: 280px;
  }
}

/* 태블릿/모바일 — 단일 컬럼 스택 (1440 이하 2컬럼만 있고 그 아래가 없었음) */
@media (max-width: 768px) {
  /* 본문 좌우 여백·패딩 축소 */
  .home__body {
    margin: 0 8px;
    padding: 16px 14px 40px;
  }

  /* 3컬럼 → 단일 컬럼. 순서 재배치(중앙 → 우측 → 좌측)로
     좌측 컬럼 끝의 푸터가 페이지 최하단에 오도록 한다.
     결과 순서: 빠른시작/이어서하기 → 에이전트/프롬프트 → 프로필/알림/공지/푸터 */
  .home__inner {
    /* minmax(0, 1fr) 필수 — 1fr(=minmax(auto,1fr))이면 안 잘리는 긴 텍스트(프롬프트 요약 등)의
       최소폭만큼 트랙이 늘어나 카드가 가로로 폭주(오버플로)한다 */
    grid-template-columns: minmax(0, 1fr);
    gap: 16px;
  }
  .home__col:nth-child(2) {
    order: 1;
  }
  .home__col:nth-child(3) {
    order: 2;
    flex-direction: column;
  }
  .home__col:nth-child(1) {
    order: 3;
  }

  /* 1440 규칙에서 우측 컬럼을 가로 행으로 펼친 것을 단일 컬럼에선 원복 */
  .home__col:nth-child(3) > * {
    flex: initial;
    min-width: 0;
  }

  /* 프로필 — 좁은 폭에서 토큰 바를 한 줄 전체로 두고 버튼은 아랫줄로 내림.
     (flex-wrap만으론 토큰 정보가 0으로 줄고 버튼이 같은 줄에 남아 찌그러짐) */
  .home-card__token-row {
    flex-wrap: wrap;
  }
  .home-card__token-info {
    flex-basis: 100%;
  }

  /* 아바타 모바일 비율 축소 */
  .home-card__avatar {
    width: 80px;
    height: 80px;
  }
  .home-card__avatar-circle {
    font-size: 28px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/css/Home.css"],"names":[],"mappings":"AAAA;;;;;;6EAM6E;;AAE7E;EACE,iBAAiB;EACjB,6BAA6B;EAC7B;;6DAE2D;EAC3D,2BAA2B;EAC3B,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;;EAElC;6CAC2C;EAC3C,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA,sCAAsC;AACtC;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;;wDAEwD;AACxD;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;EACd,uBAAuB;EACvB,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,oBAAoB;EACpB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,kFAAkF;EAClF,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,uCAAuC;EACvC,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B;;;qCAGmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;EAC3B;;gCAE8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB;;oCAEkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,+CAA+C;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf;;2CAEyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB;;oCAEkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;AACvC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;;0DAEwD;EACxD,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gDAAgD;EAChD,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB;;;oCAGkC;EAClC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,yCAAyC;EACzC,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,UAAU;EACV,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,mCAAmC;AACnC;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf;;;qCAGmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,2BAA2B;EAC3B;;gCAE8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE;IACE,oDAAoD;EACtD;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,mDAAmD;AACnD;EACE,mBAAmB;EACnB;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;;mDAEiD;EACjD;IACE;yCACqC;IACrC,qCAAqC;IACrC,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,QAAQ;IACR,sBAAsB;EACxB;EACA;IACE,QAAQ;EACV;;EAEA,6CAA6C;EAC7C;IACE,aAAa;IACb,YAAY;EACd;;EAEA;qDACmD;EACnD;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;;EAEA,kBAAkB;EAClB;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ========================================================================\n   Home — GrowFit 신규 디자인 (Figma 29:17740 / Home - dashboard)\n   3컬럼 레이아웃: 좌측(프로필/알림/공지/푸터) · 중앙(빠른 시작/이어서 하기) · 우측(에이전트)\n   헤더는 components/AppHeader (별도 CSS)\n   폰트 사양 (피그마 Pretendard variants):\n     Light 300 · Regular 400 · Medium 500 · SemiBold 600 · Bold 700\n   ======================================================================== */\n\n.home {\n  min-height: 100vh;\n  background: var(--fg-bg-dark);\n  font-family:\n    'Pretendard Variable', 'Pretendard',\n    -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  color: var(--fg-text-basic);\n  letter-spacing: -0.005em;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  /* 홈 단일 포인트 액센트 — 네이비 구조색 + 인디고 액센트.\n     시안/앰버 등으로 바꾸려면 이 두 줄만 수정하면 화면 전체에 반영됨. */\n  --home-accent: #4c5ed9;\n  --home-accent-strong: #3a49b0;\n}\n\n/* ───────── 상단: 개인화 인사 헤더 ───────── */\n.home-greeting {\n  max-width: 1880px;\n  margin: 0 auto 24px;\n  animation: home-rise 0.5s ease both;\n}\n\n.home-greeting__title {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n  color: var(--fg-text-basic);\n}\n\n.home-greeting__name {\n  color: var(--home-accent);\n}\n\n.home-greeting__sub {\n  margin: 6px 0 0;\n  font-size: 15px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 1.4;\n}\n\n/* ───────── 진입 모션 (컬럼별 staggered reveal) ───────── */\n@keyframes home-rise {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.home__col > * {\n  animation: home-rise 0.45s ease both;\n}\n\n.home__col > *:nth-child(1) {\n  animation-delay: 0.06s;\n}\n.home__col > *:nth-child(2) {\n  animation-delay: 0.12s;\n}\n.home__col > *:nth-child(3) {\n  animation-delay: 0.18s;\n}\n.home__col > *:nth-child(4) {\n  animation-delay: 0.24s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .home-greeting,\n  .home__col > * {\n    animation: none;\n  }\n}\n\n/* ───────── 본문 ─────────\n   피그마 Contens Box BG 토큰은 #f2f2f2지만 실제 시안은 흰색 배경으로 보이므로 #fff 사용.\n   카드/리스트 항목 사이의 미세 회색 라인은 1px border와 #f8f8f8 박스로 구분. */\n.home__body {\n  background: #ffffff;\n  border-radius: 16px 16px 0 0;\n  margin: 0 16px;\n  padding: 20px 36px 60px;\n  min-height: calc(100vh - 52px);\n  box-shadow: 0 0 6.3px 1px rgba(0, 0, 0, 0.26);\n}\n\n.home__inner {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 18px;\n  max-width: 1880px;\n  margin: 0 auto;\n}\n\n.home__col {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  min-width: 0;\n}\n\n/* ───────── 카드 공통 ───────── */\n.home-card {\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  padding: 12px 16px 16px;\n}\n\n.home-card__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--fg-line);\n  margin-bottom: 4px;\n}\n\n.home-card__title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  line-height: 26px;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.home-card__title--plain {\n  font-size: 18px;\n  font-weight: 600;\n  color: #000;\n  line-height: 28px;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n\n.home-card__head-action {\n  background: transparent;\n  border: 0;\n  padding: 0;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  line-height: 17px;\n}\n\n.home-card__head-action:hover {\n  text-decoration: underline;\n}\n\n/* ───────── 프로필 카드 ───────── */\n.home-card--profile {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 20px 20px 24px;\n  background: var(--fg-bg-dark);\n  border: 0;\n  color: #fff;\n  border-radius: 12px;\n}\n\n.home-card__avatar {\n  flex-shrink: 0;\n  width: 102px;\n  height: 102px;\n  border-radius: 9999px;\n  overflow: hidden;\n  background: linear-gradient(135deg, var(--home-accent), var(--home-accent-strong));\n  display: grid;\n  place-items: center;\n}\n\n.home-card__avatar-circle {\n  display: grid;\n  place-items: center;\n  width: 100%;\n  height: 100%;\n  color: #fff;\n  font-size: 36px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n}\n\n.home-card__profile-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.home-card__profile-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.home-card__role-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 6px;\n  border: 1px solid var(--fg-line);\n  border-radius: 4px;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-bg-card);\n  line-height: 1;\n}\n\n.home-card__name {\n  flex: 1;\n  margin: 0;\n  font-size: 20px;\n  font-weight: 500;\n  color: #fff;\n  letter-spacing: -0.01em;\n}\n\n.home-card__edit-btn {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-menu);\n  cursor: pointer;\n  padding: 0;\n}\n\n.home-card__edit-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n}\n\n.home-card__token-alert {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-menu);\n  line-height: 1.2;\n}\n\n.home-card__token-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.home-card__token-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.home-card__token-label {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-menu);\n  line-height: 1;\n}\n\n.home-card__token-label > span:first-child {\n  flex: 1;\n}\n\n.home-card__token-value--alert {\n  color: var(--fg-anti-red);\n  font-weight: 600;\n}\n\n.home-card__token-bar {\n  width: 100%;\n  height: 5px;\n  background: var(--fg-text-menu);\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.home-card__token-bar-fill {\n  height: 100%;\n  background: var(--home-accent);\n  border-radius: 10px;\n  transition: width 0.3s ease;\n}\n\n.home-card__token-bar-fill--alert {\n  background: var(--fg-anti-red);\n}\n\n/* ───────── 알림 카드 ───────── */\n.home-card--alarm {\n  padding: 12px 16px 16px;\n}\n\n.home-card__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.home-card__alarm-item {\n  display: flex;\n  align-items: flex-start;\n  gap: 4px;\n  padding: 10px 10px 10px 8px;\n  background: #fff;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.home-card__alarm-item:hover {\n  background: var(--fg-bg-litepp);\n}\n\n.home-card__alarm-icon {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  display: grid;\n  place-items: center;\n  color: var(--fg-text-basic);\n}\n\n.home-card__alarm-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.home-card__alarm-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  line-height: 1;\n  letter-spacing: -0.005em;\n}\n\n.home-card__alarm-time {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 1;\n}\n\n.home-card__alarm-dot {\n  flex-shrink: 0;\n  width: 5px;\n  height: 5px;\n  margin-top: 8px;\n  background: var(--fg-anti-red);\n  border-radius: 9999px;\n}\n\n.home-card__alarm-empty {\n  padding: 10px 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n}\n\n/* ───────── 공지 사항 카드 ───────── */\n.home-card--notice {\n  padding: 12px 16px 16px;\n}\n\n.home-notice__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.home-notice__item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 0;\n  border-bottom: 1px solid var(--fg-line);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.home-notice__item:last-child {\n  border-bottom: 0;\n}\n\n.home-notice__item:hover .home-notice__title {\n  color: var(--fg-link);\n}\n\n.home-notice__title {\n  flex: 1;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  line-height: 1;\n  letter-spacing: -0.005em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.home-notice__date {\n  flex-shrink: 0;\n  margin: 0;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 1;\n  text-align: right;\n}\n\n.home-notice__empty {\n  margin: 0;\n  padding: 16px 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-gray);\n  text-align: center;\n}\n\n/* ───────── 공지 상세 모달 ───────── */\n.notice-modal__overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 24px;\n}\n\n.notice-modal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1001;\n  background: #ffffff;\n  border-radius: 12px;\n  width: min(720px, calc(100% - 48px));\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n}\n\n.notice-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.notice-modal__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  line-height: 1.4;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.notice-modal__close {\n  flex-shrink: 0;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.notice-modal__close:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: var(--fg-text-basic);\n}\n\n.notice-modal__body {\n  padding: 20px;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.notice-modal__status {\n  margin: 0;\n  padding: 24px 0;\n  text-align: center;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n}\n\n.notice-modal__status--error {\n  color: var(--fg-anti-red, #ff1500);\n}\n\n.notice-modal__meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.notice-modal__tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 8px;\n  border-radius: 9999px;\n  background: var(--fg-bg-content, #f2f2f2);\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--fg-text-gray);\n  line-height: 1;\n}\n\n.notice-modal__tag--pin {\n  background: var(--fg-anti-red, #ff1500);\n  color: #ffffff;\n}\n\n.notice-modal__date {\n  margin-left: auto;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.notice-modal__description {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.6;\n  color: var(--fg-text-basic);\n  white-space: pre-wrap;\n}\n\n.notice-modal__content-body {\n  font-size: 14px;\n  line-height: 1.7;\n  color: var(--fg-text-basic);\n  word-break: break-word;\n}\n\n.notice-modal__content-body p {\n  margin: 0 0 12px;\n}\n\n.notice-modal__content-body h1,\n.notice-modal__content-body h2,\n.notice-modal__content-body h3 {\n  margin: 16px 0 8px;\n  font-weight: 700;\n}\n\n.notice-modal__content-body ul,\n.notice-modal__content-body ol {\n  padding-left: 20px;\n  margin: 0 0 12px;\n}\n\n.notice-modal__content-body a {\n  color: var(--fg-link, var(--fg-button-hover));\n  text-decoration: underline;\n}\n\n.notice-modal__content-body img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 6px;\n}\n\n.notice-modal__content-body pre,\n.notice-modal__content-body code {\n  background: var(--fg-bg-content, #f2f2f2);\n  border-radius: 4px;\n}\n\n.notice-modal__content-body pre {\n  padding: 12px;\n  overflow-x: auto;\n}\n\n.notice-modal__content-body code {\n  padding: 1px 4px;\n  font-size: 13px;\n}\n\n/* ───────── 푸터 ───────── */\n.home-footer {\n  padding: 20px 12px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n}\n\n.home-footer__links {\n  list-style: none;\n  margin: 0 0 12px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.home-footer__links a {\n  color: var(--fg-text-basic);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.home-footer__links a:hover {\n  color: var(--fg-link-hover);\n  text-decoration: underline;\n}\n\n.home-footer__brand {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  margin-top: 12px;\n}\n\n.home-footer__brand-img--gf {\n  height: 36px;\n  width: auto;\n}\n\n.home-footer__brand-img--bct {\n  height: 24px;\n  width: auto;\n}\n\n.home-footer__copy {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic);\n  line-height: 1.4;\n}\n\n.home-footer__copy:first-of-type {\n  font-weight: 500;\n  margin-top: 8px;\n}\n\n.home-footer__copy b {\n  font-weight: 700;\n}\n\n/* ───────── 중앙: 히어로 배너 ───────── */\n/* ───────── 중앙: 빠른 시작 ───────── */\n.home-quickstart {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.home-quickstart__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.home-quickstart__grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.home-quickstart__tile {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  text-decoration: none;\n  color: var(--fg-text-basic);\n  transition:\n    border-color var(--transition-fast),\n    background-color var(--transition-fast),\n    box-shadow var(--transition-fast);\n}\n\n.home-quickstart__tile:hover {\n  border-color: var(--home-accent);\n  background: var(--fg-bg-card);\n  box-shadow: 0 2px 10px rgba(76, 94, 217, 0.12);\n}\n\n.home-quickstart__tile-icon {\n  flex-shrink: 0;\n  width: 44px;\n  height: 44px;\n  display: grid;\n  place-items: center;\n  border-radius: 10px;\n  background: var(--fg-bg-content);\n  color: var(--fg-bg-toolbox);\n  transition:\n    background-color var(--transition-fast),\n    color var(--transition-fast);\n}\n\n.home-quickstart__tile:hover .home-quickstart__tile-icon {\n  background: var(--home-accent);\n  color: #fff;\n}\n\n.home-quickstart__tile-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.home-quickstart__tile-label {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  line-height: 22px;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.home-quickstart__tile-desc {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 16px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.home-quickstart__tile-arrow {\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  color: var(--fg-line);\n  transition:\n    color var(--transition-fast),\n    transform var(--transition-fast);\n}\n\n.home-quickstart__tile:hover .home-quickstart__tile-arrow {\n  color: var(--home-accent);\n  transform: translateX(2px);\n}\n\n/* ───────── 버튼 (프로필 카드 안 충전/업그레이드) ───────── */\n.home-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 32px;\n  padding: 5px 7px 7px;\n  background: var(--home-accent);\n  border: 0;\n  border-radius: 4px;\n  color: #fff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: var(--transition-fast);\n}\n\n.home-btn:hover {\n  background: var(--home-accent-strong);\n}\n\n/* ───────── 중앙: 이어서 하기 ───────── */\n.home-continue {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.home-continue__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.home-continue__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.home-continue__item {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition:\n    border-color var(--transition-fast),\n    background-color var(--transition-fast);\n}\n\n.home-continue__item:hover {\n  background: #fff;\n  border-color: var(--home-accent);\n}\n\n.home-continue__item-logo {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  border-radius: 9999px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n}\n\n.home-continue__item-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.home-continue__item-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  line-height: 20px;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.home-continue__item-meta {\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 16px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.home-continue__item-arrow {\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  color: var(--fg-line);\n  transition:\n    color var(--transition-fast),\n    transform var(--transition-fast);\n}\n\n.home-continue__item:hover .home-continue__item-arrow {\n  color: var(--home-accent);\n  transform: translateX(2px);\n}\n\n.home-continue__loading {\n  margin: 0;\n  padding: 20px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-gray);\n  text-align: center;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n}\n\n.home-continue__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 28px 16px;\n  background: #f8f8f8;\n  border-radius: 12px;\n  text-align: center;\n}\n\n.home-continue__empty-text {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-gray);\n}\n\n.home-continue__start {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  height: 36px;\n  padding: 0 16px;\n  background: var(--home-accent);\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color var(--transition-fast);\n}\n\n.home-continue__start:hover {\n  background: var(--home-accent-strong);\n}\n\n/* ───────── 우측: 에이전트 섹션 ───────── */\n.home-agent-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  /* width:100% 필수 — 단일 컬럼 스택(모바일)에서 이 flex 컬럼이 부모 폭에 stretch되지 않고\n     내부 nowrap 텍스트(에이전트 제목·설명, 프롬프트 요약)의 max-content로 늘어나\n     카드가 가로로 폭주한다. 명시적 100%로 트랙(컬럼) 폭에 고정. 데스크탑에선 no-op. */\n  width: 100%;\n  min-width: 0;\n}\n\n.home-agent-section__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n}\n\n.home-agent__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.home-agent__empty {\n  padding: 16px;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-gray, var(--fg-text-basic));\n  background: #f8f8f8;\n  border-radius: 12px;\n  text-align: center;\n}\n\n.home-agent__item {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 16px;\n  background: var(--fg-bg-card, #fbfbfb);\n  border-radius: 12px;\n  transition:\n    background-color var(--transition-fast),\n    box-shadow var(--transition-fast),\n    transform var(--transition-fast);\n  cursor: pointer;\n}\n\n.home-agent__item:hover {\n  background: #fff;\n  box-shadow: 0 2px 10px rgba(76, 94, 217, 0.1);\n}\n\n.home-agent__thumb {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 9999px;\n  display: grid;\n  place-items: center;\n  overflow: hidden;\n  background: var(--fg-bg-card, #fbfbfb);\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.home-agent__item:hover .home-agent__thumb {\n  background: #ffffff;\n}\n\n.home-agent__thumb--dark {\n  background: var(--fg-bg-toolbox);\n  color: #fff;\n}\n\n.home-agent__thumb--bct {\n  background: var(--fg-bg-card);\n  color: var(--fg-text-basic);\n  border: 1px solid var(--fg-line);\n}\n\n.home-agent__thumb--empty {\n  background: var(--fg-bg-content, #f2f2f2);\n  color: var(--fg-text-gray);\n}\n\n.home-agent__thumb-initial {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  place-items: center;\n  font-size: 18px;\n  font-weight: 700;\n  color: inherit;\n  letter-spacing: -0.01em;\n}\n\n.home-agent__thumb-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n.home-agent__thumb-empty {\n  display: grid;\n  place-items: center;\n  color: var(--fg-text-gray);\n}\n\n.home-agent__body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.home-agent__title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  line-height: 28px;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.home-agent__desc {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic);\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.home-agent__meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 12px;\n}\n\n.home-agent__stats {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.home-agent__stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-gray);\n  line-height: 1;\n}\n\n.home-agent__rank-delta {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1;\n}\n\n.home-agent__rank-delta--up {\n  color: var(--fg-anti-red);\n}\n\n.home-agent__rank-delta--down {\n  color: var(--fg-button-hover);\n}\n\n.home-agent__actions {\n  display: inline-flex;\n  align-items: center;\n}\n\n.home-agent__action-count {\n  font-family: var(--font-sans);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1;\n  color: var(--fg-anti-red, #ff1500);\n  white-space: nowrap;\n  padding: 0 2px;\n}\n\n.home-agent__icon-btn {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  padding: 0;\n  transition: var(--transition-fast);\n}\n\n.home-agent__icon-btn:hover {\n  background: rgba(0, 0, 0, 0.05);\n  color: var(--fg-text-basic);\n}\n\n.home-agent__icon-btn--favorited {\n  color: var(--fg-anti-red, #ff1500);\n}\n\n.home-agent__icon-btn--favorited:hover {\n  color: var(--fg-anti-red, #ff1500);\n}\n\n/* ───────── 우측: 내 프롬프트 ───────── */\n.home-prompt__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.home-prompt__item {\n  width: 100%;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 14px 16px;\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition:\n    border-color var(--transition-fast),\n    background-color var(--transition-fast),\n    box-shadow var(--transition-fast);\n}\n\n.home-prompt__item:hover {\n  background: #fff;\n  border-color: var(--home-accent);\n  box-shadow: 0 2px 10px rgba(76, 94, 217, 0.1);\n}\n\n.home-prompt__icon {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  border-radius: 9px;\n  background: var(--fg-bg-content);\n  color: var(--fg-bg-toolbox);\n  transition:\n    background-color var(--transition-fast),\n    color var(--transition-fast);\n}\n\n.home-prompt__item:hover .home-prompt__icon {\n  background: var(--home-accent);\n  color: #fff;\n}\n\n.home-prompt__body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.home-prompt__head {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n}\n\n.home-prompt__title {\n  flex: 1;\n  min-width: 0;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  line-height: 22px;\n  letter-spacing: -0.01em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.home-prompt__date {\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 1;\n}\n\n.home-prompt__summary {\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 18px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ───────── 반응형 ───────── */\n@media (max-width: 1440px) {\n  .home__inner {\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n  }\n  .home__col:nth-child(3) {\n    grid-column: 1 / -1;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 20px;\n  }\n  .home__col:nth-child(3) > * {\n    flex: 1 1 280px;\n    min-width: 280px;\n  }\n}\n\n/* 태블릿/모바일 — 단일 컬럼 스택 (1440 이하 2컬럼만 있고 그 아래가 없었음) */\n@media (max-width: 768px) {\n  /* 본문 좌우 여백·패딩 축소 */\n  .home__body {\n    margin: 0 8px;\n    padding: 16px 14px 40px;\n  }\n\n  /* 3컬럼 → 단일 컬럼. 순서 재배치(중앙 → 우측 → 좌측)로\n     좌측 컬럼 끝의 푸터가 페이지 최하단에 오도록 한다.\n     결과 순서: 빠른시작/이어서하기 → 에이전트/프롬프트 → 프로필/알림/공지/푸터 */\n  .home__inner {\n    /* minmax(0, 1fr) 필수 — 1fr(=minmax(auto,1fr))이면 안 잘리는 긴 텍스트(프롬프트 요약 등)의\n       최소폭만큼 트랙이 늘어나 카드가 가로로 폭주(오버플로)한다 */\n    grid-template-columns: minmax(0, 1fr);\n    gap: 16px;\n  }\n  .home__col:nth-child(2) {\n    order: 1;\n  }\n  .home__col:nth-child(3) {\n    order: 2;\n    flex-direction: column;\n  }\n  .home__col:nth-child(1) {\n    order: 3;\n  }\n\n  /* 1440 규칙에서 우측 컬럼을 가로 행으로 펼친 것을 단일 컬럼에선 원복 */\n  .home__col:nth-child(3) > * {\n    flex: initial;\n    min-width: 0;\n  }\n\n  /* 프로필 — 좁은 폭에서 토큰 바를 한 줄 전체로 두고 버튼은 아랫줄로 내림.\n     (flex-wrap만으론 토큰 정보가 0으로 줄고 버튼이 같은 줄에 남아 찌그러짐) */\n  .home-card__token-row {\n    flex-wrap: wrap;\n  }\n  .home-card__token-info {\n    flex-basis: 100%;\n  }\n\n  /* 아바타 모바일 비율 축소 */\n  .home-card__avatar {\n    width: 80px;\n    height: 80px;\n  }\n  .home-card__avatar-circle {\n    font-size: 28px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
